import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82ec161a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_4 = { class: "hound-card__info" }
const _hoisted_5 = { class: "hound-card__stamina-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_stamina_refill_modal = _resolveComponent("stamina-refill-modal")!
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createBlock(_component_n_card, {
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openHound(_ctx.hound.id.toString()))),
    hoverable: "",
    class: "hound-card-container",
    style: {"margin-bottom":"1.5rem"},
    size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["hound-card avatar", `
        avatar-component-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[3]}
        avatar-neon-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[2]}
      `])
      }, [
        _createElementVNode("div", null, [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_n_space, { align: "center" }, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, [
                  (_ctx.breakpoints.sDown.matches)
                    ? (_openBlock(), _createBlock(_component_n_ellipsis, {
                        key: 0,
                        style: {"max-width":"6.5rem"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                      ], 64))
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.hound.firstPlace) + "/" + _toDisplayString(_ctx.hound.secondPlace) + "/" + _toDisplayString(_ctx.hound.thirdPlace), 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.hound.sex), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_n_space, {
            justify: "center",
            style: {"height":"100%"},
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_progress, {
                color: "#C7FC18",
                class: "hound-card__stamina",
                type: "line",
                percentage: _ctx.staminaPercentage
              }, null, 8, ["percentage"]),
              (_ctx.staminaPercentage < 100)
                ? (_openBlock(), _createBlock(_component_n_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStaminaModal=true)),
                    circle: "",
                    ghost: "",
                    size: "small",
                    type: "primary"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_plus_icon)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 2),
      _createVNode(_component_n_modal, {
        show: _ctx.showStaminaModal,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showStaminaModal) = $event)),
        style: {"width":"max-content"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_stamina_refill_modal, {
            onRefillStamina: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refillStamina'))),
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showStaminaModal=false)),
            hound: _ctx.hound
          }, null, 8, ["hound"])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["size"]))
}